import { Dispatch } from 'redux'
import { Flags } from 'types/profile'
import * as mainApi from 'util/server/mainApi'

type SetFlags = Dispatch<{
  type: 'SET_FLAGS'
  flags: Flags
}>

type PrivacySettings = {
  [privacySetting: string]: boolean
}

export function setPrivacySettings(profile_id: number, privacy_settings: PrivacySettings) {
  return (dispatch: SetFlags) => {
    return mainApi.updatePrivacySettings(profile_id, privacy_settings).then(async (resp) => {
      const { flags } = resp.data
      return dispatch({ type: 'SET_FLAGS', flags })
    })
  }
}
